import { useQuery } from "@tanstack/react-query";
import { GET_SHIPPING_COUNTRIES } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IShippingCountry } from "@/types/apiResponse.types";

export const useGetAllFromCountriesRequest = () => {
  return useQuery<{ data: { data: IShippingCountry[] } }>({
    queryKey: [GET_SHIPPING_COUNTRIES],
    queryFn: () => apiRequest(GET_SHIPPING_COUNTRIES, "get"),
  });
};
